"use client";

import Image from "next/image";
import { motion, useReducedMotion } from "framer-motion";
import ResponsiveCopy from "../../ui/ResponsiveCopy";

function FeatureCard({ card, index }) {
  const reducedMotion = useReducedMotion();
  return (
    <motion.div
      initial={reducedMotion ? false : { opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, amount: 0.15 }}
      transition={{ duration: reducedMotion ? 0 : 0.85, delay: reducedMotion ? 0 : index * 0.16, ease: "easeOut" }}
      className="relative flex flex-col items-center gap-5 overflow-hidden rounded-[16px] border border-white/20 bg-black/60 p-5 shadow-[inset_0px_4px_4px_0px_rgba(255,255,255,0.1)] sm:flex-row md:h-[142px] lg:backdrop-blur-[10px]"
    >
      <div
        className="relative h-[160px] w-full shrink-0 overflow-hidden rounded-xl sm:h-[110px] sm:w-[170px]"
      >
        <div className="absolute inset-0">
          <Image src={card.img} alt={card.imgAlt} fill sizes="(max-width: 639px) calc(100vw - 88px), 170px" className="object-contain object-center sm:object-left" />
        </div>
      </div>
      <div className="flex min-w-0 flex-col gap-2">
        <h2 className="text-xl font-bold text-white">
          <ResponsiveCopy desktop={card.title} mobile={card.titleMobile} />
        </h2>
        <p className="text-base text-white/90">
          <ResponsiveCopy desktop={card.desc} mobile={card.descMobile} />
        </p>
      </div>
    </motion.div>
  );
}

export default function FeatureCardsRow({ cards }) {
  return <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2">{cards.map((card, index) => <FeatureCard key={card.img} card={card} index={index} />)}</div>;
}
